// Who may switch a desk's work profile mid-session, and what the desk says about
// the rule and about a switch somebody else made (calling-rules §13.6, §13.8).
import { t, type StaffLanguage } from './staffText'
import type { CounterView } from './types'

/** busy while any customer is at the desk: the server refuses with COUNTER_BUSY. */
export function mayChangeProfile(desk: Pick<CounterView, 'sessionId' | 'ticketId'>): 'ok' | 'busy' | 'closed' {
  if (!desk.sessionId) return 'closed'
  return desk.ticketId ? 'busy' : 'ok'
}

/** Which rule of the work profile chose the desk's customer, for the floor's desk detail (supervisors only). */
export function ruleTag(chosenBy: CounterView['chosenBy'], lang: StaffLanguage): string | null {
  if (!chosenBy) return null
  return chosenBy.rule === 0 ? t('eq.counter.finally', lang) : t('eq.counter.rule', lang, { n: chosenBy.rule })
}

/** A toast when somebody else changed this desk's profile: never on first sight,
 *  on sign-in or sign-out, on a new session, or for the viewer's own change. */
export function profileNotice(
  prev: { workProfileId?: string; sessionId?: string } | undefined,
  next: Pick<CounterView, 'workProfileId' | 'profileName' | 'profileChangedBy' | 'sessionId'>,
  viewerId: string,
  lang: StaffLanguage,
): string | null {
  if (!prev?.workProfileId || !next.workProfileId || prev.workProfileId === next.workProfileId) return null
  if (prev.sessionId && next.sessionId && prev.sessionId !== next.sessionId) return null
  const by = next.profileChangedBy
  if (by?.staffId === viewerId) return null
  const name = next.profileName ?? ''
  return by?.staffName ? t('eq.counter.changedBy', lang, { who: by.staffName, name }) : t('eq.counter.changed', lang, { name })
}
